import React, { useEffect, useState } from "react";
import { Button, Switch } from "antd";
// import iran from "../../images/setting/iran.png";
// import germany from "../../images/setting/germany.png";
// import france from "../../images/setting/france.png";
// import uk from "../../images/setting/uk.png";
import BottomSheet from "../../components/BottomSheet";
import PageContainer from "../../components/PageContainer";
import OTPConfirm from "./otpConfirm/OTPConfirm";
import { get, set } from "idb-keyval";
import WarningOutlined from "@ant-design/icons/lib/icons/WarningOutlined";

function Setting() {
  const [confirmComponent, setConfirmComponent] = useState(false);
  // Set NightMode State Based On IndexDb
  const [nightMode, setNightMode] = useState(true);
  // Set Push Notification State Based On IndexDb
  const [notificationStatus, setNotificationStatus] = useState(false);

  function toggleConfirm() {
    setConfirmComponent(!confirmComponent);
  }

  useEffect(() => {
    get("nightMode").then((nightModeIdb) => {
      setNightMode(nightModeIdb !== undefined ? nightModeIdb : true);
    });

    get("notificationStatus").then((notificationStatusIdb) => {
      setNotificationStatus(
        notificationStatusIdb !== undefined ? notificationStatusIdb : true
      );
    });
  }, []);

  useEffect(() => {
    set("nightMode", nightMode);
  }, [nightMode]);

  useEffect(() => {
    set("notificationStatus", notificationStatus);
  }, [notificationStatus]);

  const notificationStatusChangeHandler = (isChecked) => {
    setNotificationStatus(isChecked);
  };

  const nightModeChangeHandler = (isChecked) => {
    setNightMode(isChecked);
  };

  return (
    <PageContainer
      classNames="setting"
      headerProps={{
        right: "",
        link: "/menu",
        content: "تنظیمات",
      }}
    >
      <div className="wrap-setting">
        <ul className="boxes">
          <li className="box internal-messages">
            <h3 className="title">پیام های درون اپلیکیشنی</h3>
            <div className="body">
              <div className="item">
                <span>پیام های درون اپلیکیشنی</span>
                <Switch
                  onChange={(isChecked) => {
                    notificationStatusChangeHandler(isChecked);
                  }}
                  checked={notificationStatus}
                />
              </div>
              <div className="item mode">
                <span>حالت شبانه</span>
                <Switch
                  onChange={(isChecked) => {
                    nightModeChangeHandler(isChecked);
                  }}
                  checked={nightMode}
                  disabled={!notificationStatus} // Disable nightMode When Push Notification Is Disabled
                />
              </div>
              <div>
                <WarningOutlined style={{ marginLeft: 5 }} />
                ساعات حالت شبانه از 12 شب تا 7 صبح است
              </div>
            </div>
          </li>
          <li className="box delete-account">
            <h3 className="title">حذف تمامی اطلاعات من از لاوین</h3>
            <div className="body">
              <p>
                در راستای احترام به حقوق حریم خصوصی کاربران لاوین این امکان برای
                شما فراهم شده تا از طریق این بخش تمامی اطلاعات خود را از سخت
                افزار ها و نرم افزار های لاوین حذف کنید
              </p>
              <Button onClick={toggleConfirm}>حذف اطلاعات</Button>
            </div>
          </li>
        </ul>
        <BottomSheet
          setClose={toggleConfirm}
          isOpen={confirmComponent}
          className="otp-confirm"
        >
          <OTPConfirm setClose={toggleConfirm} />
        </BottomSheet>
      </div>
    </PageContainer>
  );
}

export default Setting;
